import { render, staticRenderFns } from "./KpiCard.vue?vue&type=template&id=02c2c13b&scoped=true"
import script from "./KpiCard.vue?vue&type=script&lang=js"
export * from "./KpiCard.vue?vue&type=script&lang=js"
import style0 from "./KpiCard.vue?vue&type=style&index=0&id=02c2c13b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02c2c13b",
  null
  
)

export default component.exports